import {
    AccountCircle,
    Mail,
    Password,
    PasswordRounded,
    VpnKey,
} from "@mui/icons-material";
import {
    CircularProgress,
    Grid,
    InputAdornment,
    TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { login, reset } from "../../Redux/AuthSlice/AuthSlice";

// validate the form in login
const validationSchema = yup.object({
    email: yup
        .string("Enter your email")
        .email("Enter a valid email")
        .required("Email is required"),
    password: yup
        .string("Enter your password")
        .min(8, "Password should be of minimum 8 characters length")
        .required("Password is required"),
});

// start a login function
const LoginForm = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { mainUser, isError, isSuccess, isLodaing, massage } = useSelector(
        (state) => state.auth
    );
    // initial value for form
    const formik = useFormik({
        initialValues: {
            email: "",
            password: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            await dispatch(login(values));
            await dispatch(reset());
        },
    });

    useEffect(() => {
        //if there is an error
        if (isError) {
            toast.error(massage);
        }

        //if the login sucsess
        if (isSuccess || mainUser) {
            navigate("/dashboard/app");
        }

        //dispatch reset
        dispatch(reset());
    }, [mainUser, isError, isSuccess, massage, navigate]);

    ///////////////////logout
    // const logoutHandel = () => {
    //   if (mainUser) {
    //     dispatch(logout());
    //   }
    // };

    // the data return
    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container>
                <Grid item mb={2} xs={12}>
                    <TextField
                        fullWidth
                        id="input-with-icon-textfield"
                        name="email"
                        label="Email"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Mail />
                                </InputAdornment>
                            ),
                        }}
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        error={
                            formik.touched.email && Boolean(formik.errors.email)
                        }
                        helperText={formik.touched.email && formik.errors.email}
                    />
                </Grid>
                <Grid item mb={2} xs={12}>
                    <TextField
                        fullWidth
                        id="input-with-icon-textfield"
                        name="password"
                        label="Password"
                        type="password"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <VpnKey />
                                </InputAdornment>
                            ),
                        }}
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        error={
                            formik.touched.password &&
                            Boolean(formik.errors.password)
                        }
                        helperText={
                            formik.touched.password && formik.errors.password
                        }
                    />
                </Grid>
            </Grid>

            <PrimaryButton fullWidth type="submit">
                {!isLodaing ? (
                    <span>Login</span>
                ) : (
                    <CircularProgress color="inherit" sx={{ width: "20px" }} />
                )}
            </PrimaryButton>
        </form>
    );
};

export default LoginForm;
